module.exports = Backbone;


/*****************
 ** WEBPACK FOOTER
 ** external "Backbone"
 ** module id = 348
 ** module chunks = 46 47
 **/